import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import withExperimentProvider from 'components/hocs/withExperimentProvider'
import RichCta from 'components/rich-cta'
import WidgetPage from 'components/hocs/widget-page'
import CreditCardForm from 'components/form/credit-card'

import MiniMarketplace from './mini-marketplace'

export const RichCtaApp = ({ analyticsContexts, utms, theme, variation, ...props }) =>
  theme.includes('fox') && variation === 'interactive' ? (
    <MiniMarketplace analyticsContexts={analyticsContexts} utms={utms} theme={theme} />
  ) : (
    <RichCta
      url={`${config.credibleRoot}/credit-cards/all-credit-cards`}
      title="Find the right credit card for your financial goals."
      body="Cards for cash back, rewards, travel, balance transfer and more."
      ctaText="Compare Cards"
      form={CreditCardForm}
      analyticsContexts={analyticsContexts}
      utms={utms}
      theme={theme}
      variation={variation}
      {...props}
    />
  )

RichCtaApp.propTypes = {
  analyticsContexts: PropTypes.array,
  utms: PropTypes.object,
  theme: PropTypes.string,
  variation: PropTypes.string,
}

RichCtaApp.defaultProps = {
  theme: '',
}

export default withExperimentProvider(WidgetPage(RichCtaApp))
